import request from "@/utils/request.js";
// let path = "/api";
const ExpertTeam = {
  /**
   * 查询
   * @param expertName @type String 专家名称
   * @param startTime @type String 起始时间
   * @param endTime @type String 截止时间
   * @param page @type  Number 页码
   * @param pageSize @type Number 条数
   */
  queryList: async (data) => {
    return await request("post", "/record-center/expert/list", data);
  },
  /**
   * 添加或修改
   * @param id @type String 新增不要 修改必传
   * @param delStatus @type Number 删除状态（0：未删除，1：已删除）
   * @param expertName @type String 专家姓名
   * @param expertBelong @type String 所属单位
   * @param expertTitle @type String 专家职称
   * @param expertImgUrl @type String 专家照片 URL
   * @param enable @type Number 启用状态（1：启用，0：禁用）
   */
  addOrUpDateList: async (data) => {
    return await request("post", "/record-center/expert/add", data);
  },

  /**
   * 删除
   * @param id @type String 删除id
   */
  delList: async (data) => {
    return await request("get", "/record-center/expert/logic-del", data);
  },
};
export default ExpertTeam;



// WEBPACK FOOTER //
// ./src/api/expertTeam.js